import { render, staticRenderFns } from "./MatriculasCard.vue?vue&type=template&id=9516213c&scoped=true"
import script from "./MatriculasCard.vue?vue&type=script&lang=js"
export * from "./MatriculasCard.vue?vue&type=script&lang=js"
import style0 from "./MatriculasCard.vue?vue&type=style&index=0&id=9516213c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9516213c",
  null
  
)

export default component.exports